import { AbstractHTMLMesh } from '@/_models/virtualStaging/HTMLMesh/component/AbstractHTMLMesh';
import { LoadingState } from '@/_models/virtualStaging/VSObject';
import { createHTMLMesh } from '@/_models/virtualStaging/HTMLMesh/HTMLMesh';
import { Inputs } from '@/_models/virtualStaging/HTMLMesh/component/CollectPopup/types';

export class CollectPopupComponent extends AbstractHTMLMesh {
  public mesh;

  public hostPose;

  inputs: Inputs = {
    position: { x: 0, y: 0, z: 0 },
    scale: 0.5,
    visible: true,
    html: null,
    pose: null,
  };

  onInit() {
    const { html } = this.inputs;
    this.hostPose = this.inputs.pose;
    this.initRoot();
    this.initMesh(html);
    this.root.position.set(this.inputs.position.x, this.inputs.position.y, this.inputs.position.z);
    this.getXRController();
    this.outputs.loadingState = LoadingState.Loaded;
  }

  initMesh(html) {
    this.mesh = createHTMLMesh(html, this.context.three);
    this.mesh.material.side = this.context.three.DoubleSide;
    this.mesh.material.depthWrite = false;
    this.mesh.material.depthTest = false;
    this.mesh.renderOrder = 970;
    this.mesh.scale.setScalar(2);
    this.mesh.userData = { isPointerOver: false };
    this.pivot.add(this.mesh);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  cycleVR(_session) {}

  setHostPose(pose) {
    this.hostPose = pose;
  }

  setPositionFromPose(pose) {
    this.root.lookAt(pose.position.x, pose.position.y - 0.1, pose.position.z);
  }

  setFromHostPose() {
    this.setPositionFromPose(this.hostPose);
  }

  destroy() {
    this.pivot.remove(this.mesh);
    this.mesh.geometry.dispose();
    this.mesh.material.dispose();
    this.pivot.removeFromParent();
    this.root.removeFromParent();
    this.inputs.html.remove();
  }

  onTick() {
    if (this.hostPose) this.setFromHostPose();
    if (this.context?.renderer?.xr?.isPresenting) {
      const _session = this.context.renderer.xr.getSession();
      _session.requestAnimationFrame(() => this.cycleVR(_session));
    }
  }
}

export const collectPopupComponentType = 'mp.collectPopupComponent';
export const makeCollectPopupComponent = (): any => new CollectPopupComponent();
